import React, { useEffect, useState } from "react";
import { InfoSection } from "../../components";
import { useLocation } from "react-router-dom";
import Gallery from "../../components/Gallery/Gallery";
import TextDisplay from "../../components/TextDisplay/TextDisplay";
import ImageSlider from "../../components/Slider/Slider";
import UserDirectory from "../../components/Userdirectory/Userdirectory";

const GovernancePDF = () => {
    return (
        <div style={{
            width: "100%",
            minHeight: "100vh",
            background: "#ffffff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "40px 20px",
            boxSizing: "border-box",
        }}>
            {/* Header */}
            <div style={{
                width: "100%",
                maxWidth: 960,
                marginBottom: 24,
            }}>
                <div style={{
                    fontSize: 11,
                    letterSpacing: 4,
                    textTransform: "uppercase",
                    color: "#000",
                    marginBottom: 6,
                    fontFamily: "'DM Sans', sans-serif",
                }}>
                    Official Document
                </div>
                <h2 style={{
                    margin: 0,
                    fontSize: 26,
                    fontWeight: 700,
                    color: "#1a1a2e",
                    letterSpacing: -0.5,
                    fontFamily: "'Georgia', serif",
                }}>
                    Governance
                </h2>
                {/* Divider */}
                <div style={{
                    marginTop: 16,
                    height: 3,
                    width: "100%",
                    background: "linear-gradient(90deg, #6366f1, #a78bfa, transparent)",
                    borderRadius: 4,
                }} />
            </div>

            {/* PDF Viewer Card */}
            <div style={{
                width: "100%",
                maxWidth: 960,
                borderRadius: 16,
                overflow: "hidden",
                boxShadow: "0 4px 40px rgba(0,0,0,0.10), 0 0 0 1px rgba(99,102,241,0.1)",
                background: "#fff",
            }}>
                <iframe
                    src="/governance.pdf#toolbar=0&navpanes=0&scrollbar=1&view=FitH"
                    title="Governance Document"
                    style={{
                        width: "100%",
                        height: "82vh",
                        border: "none",
                        display: "block",
                    }}
                />
            </div>

            {/* Footer note */}
            <p style={{
                marginTop: 16,
                fontSize: 12,
                color: "#9ca3af",
                fontFamily: "'DM Sans', sans-serif",
                letterSpacing: 0.5,
            }}>
                Scroll inside the document to navigate pages
            </p>
        </div>
    );
};

function Dynamicpage() {
  const [data, setdata] = useState([]);
  const [userData, setUserData] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const pagename = queryParams.get("page");

  const GetImageData = async (orgId) => {
    const sendData2 = {
      OrgId: Number(orgId),
      ActiveStatus: "A",
      Type: "Zangie_DynamicWebsite " + pagename,
    };

    //console.log(sendData2);
    //console.log(pagename);

    try {
      const response = await fetch(
        `https://zaingielatestapi.azurewebsites.net/api/Bill/Getwebsitedatadynamic`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData2),
        },
      );

      const data = await response.json();
      console.log("Raw data:", data);

      // Convert strings to booleans (supports array or object)
      const convertBooleans = (obj) => {
        return Object.fromEntries(
          Object.entries(obj).map(([key, value]) => {
            if (value === "true") return [key, true];
            if (value === "false") return [key, false];
            return [key, value];
          }),
        );
      };

      let convertedData;

      if (Array.isArray(data)) {
        convertedData = data.map(convertBooleans);
      } else {
        convertedData = convertBooleans(data);
      }

      //console.log("Converted data:", convertedData);
      setdata(convertedData);
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  const fetchUserData = async (orgId) => {
    const sendData2 = {
      OrgId: orgId,
      Skip: 0,
      Take: 1000,
    };
    try {
      const response = await fetch(
        `https://zaingielatestapi.azurewebsites.net/api/FLOW/GetusersZangieNew`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData2),
        },
      );
      const data = await response.json();
      //console.log("Data: ", data)
      setUserData(data);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const sendData2 = {
        ActualWebsite: window.location.hostname,
        //ActualWebsite: "dev-lok.com",
        OrgName: "test",
      };

      try {
        await fetch(
          `https://zaingielatestapi.azurewebsites.net/api/FLOW/Getorgiddynamic`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData2),
          },
        )
          .then((response) => response.json())
          .then((data) => {
            const orgid = data.orgId;
            GetImageData(orgid);
            fetchUserData(orgid);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagename]);

    return (
        <>
            {data
                .filter(
                    (s) =>
                        s.description !== "ZangieImage" &&
                        s.description !== "ZangieImageGallary" &&
                        s.description !== "ZangieMembers" &&
                        s.img !==
                        "https://mountsfileupload.azurewebsites.net/api/FileUpload/",
                )
                .map((main, index) => (
                    <InfoSection key={index} {...main} />
                ))}

            {data.filter((s) => s.description === "ZangieImage").length > 0 ? (
                <Gallery data={data.filter((s) => s.description === "ZangieImage")} />
            ) : null}

            {data.filter((s) => s.description === "ZangieImageGallary").length > 0 ? (
                <ImageSlider
                    data={data.filter((s) => s.description === "ZangieImageGallary")}
                />
            ) : null}

            {data.filter(
                (s) =>
                    s.img ===
                    "https://mountsfileupload.azurewebsites.net/api/FileUpload/" &&
                    s.description !== "ZangieMembers",
            ).length > 0 ? (
                <TextDisplay
                    data={data.filter(
                        (s) =>
                            s.img ===
                            "https://mountsfileupload.azurewebsites.net/api/FileUpload/" &&
                            s.description !== "ZangieMembers",
                    )}
                />
            ) : null}

            {data.filter((s) => s.description === "ZangieMembers").length > 0 &&
                userData &&
                userData.users &&
                userData.users.length > 0 ? (
                <div style={{ background: "#f9fafb", padding: "20px 0" }}>
                    <UserDirectory userData={userData} />
                </div>
            ) : null}

            {/* ✅ PDF now shows last */}
            {pagename === "Governance" && window.location.hostname === "dev-lok.com" && <GovernancePDF />}
        </>
    );
}

export default Dynamicpage;
